/* eslint-disable react/jsx-no-literals -- Allow hard-coded translations for now */
'use client'

import { type JSX } from 'react'

import { useGlobalConfigContext } from '../../../../../global-config'
import { LOCALE } from '../../../../../i18n'
import { ProductPriceExplainerSection } from '../ProductPriceExplainerSection'

export const ProductPriceExplainerContentCh = (): JSX.Element => {
  const { locale } = useGlobalConfigContext()

  return (
    <div className="flex flex-col gap-6">
      <ProductPriceExplainerSection>
        {locale === LOCALE.DE_CH && (
          <p>
            Der angezeigte Streichpreis stellt den ermittelten Konkurrenzpreis
            für das Produkt dar. Der Rabattprozentsatz vergleicht unseren
            Angebotspreis mit dem ermittelten Konkurrenzpreis.
          </p>
        )}
        {locale === LOCALE.FR_CH && (
          <p>
            Économie totale par rapport aux prix moyen constaté sur un grand
            panel de pharmacies, réduction éventuelle incluse.
          </p>
        )}
      </ProductPriceExplainerSection>
    </div>
  )
}
